import { CircularProgress, IconButton, TextField } from '@mui/material'
import { Delete as DeleteIcon, GetApp as GetAppIcon, Visibility } from '@mui/icons-material'
import { memo, useState } from 'react'
import { getFieldId } from '../utils/utils'
import LongMenu from './LongMenu'
import FileViewer from '../../../components/Dashboard/PreviewComponent/components/FileViewer'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { extractDisplayName } from '../../../utility/fileUtil'
import FieldHistory from '../../../components/DataEntry/FieldHistory'

export const FilePreviewField = ({
  id,
  field,
  value,
  download,
  clear,
  label = null,
  placeholder = null,
  className = '',
  disabled = false,
  loading = false,
  helperText = null,
  isTableCell = false,
  dynamicListData,
  allValues,
  processContext,
  processId,
  inputSx = {},
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false)
  const { user } = useAuthContext()

  const handlePreviewClick = () => setIsViewerOpen(true)

  const options = [
    {
      label: 'Preview',
      icon: (
        <IconButton size="small">
          <Visibility />
        </IconButton>
      ),
      onClick: () => handlePreviewClick(value),
    },
    {
      label: 'Download',
      icon: (
        <IconButton size="small">
          {loading ? (
            <CircularProgress color="info" size="25px" />
          ) : (
            <GetAppIcon color="info" size="small" />
          )}
        </IconButton>
      ),
      onClick: download,
    },
    {
      label: 'Delete',
      icon: (
        <IconButton size="small" disabled={disabled}>
          <DeleteIcon disabled={disabled} size="small" />
        </IconButton>
      ),
      onClick: disabled ? undefined : clear,
    },
  ]

  const previewDialogs = (
    <FileViewer
      open={isViewerOpen}
      onClose={() => setIsViewerOpen(false)}
      fileKey={value}
      user={user}
      onDownload={download}
    />
  )

  if (!field || field.is_subfield) {
    return (
      <div className="mui-field" id="file-preview">
        <TextField
          id={getFieldId(id)}
          variant="outlined"
          color="primary"
          size="small"
          sx={{
            '& .MuiInputBase-root': {
              height: 35,
            },
            '& .MuiOutlinedInput-input.Mui-disabled': {
              WebkitTextFillColor: '#27104e',
            },
            ...inputSx,
          }}
          fullWidth
          label={label}
          placeholder={placeholder}
          value={extractDisplayName(value)}
          className={className}
          name={getFieldId(id)}
          error={!!helperText}
          disabled={disabled}
        />

        {!isTableCell && <LongMenu options={options} />}
        {previewDialogs}
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <FieldHistory
        fieldId={field?.id}
        field={field}
        helperText={helperText}
        dynamicListData={processContext?.dynamicListData}
        processId={processId}
        allValues={allValues}
      >
        <TextField
          id={getFieldId(id)}
          variant="outlined"
          color="primary"
          sx={{
            '& .MuiInputBase-root': {
              height: 33,
            },
            '& .MuiOutlinedInput-input.Mui-disabled': {
              WebkitTextFillColor: '#27104e',
            },
            ...inputSx,
          }}
          fullWidth
          label={label}
          placeholder={placeholder}
          value={extractDisplayName(value)}
          className={className}
          name={getFieldId(id)}
          error={!!helperText}
          disabled={disabled}
          size="small"
        />
      </FieldHistory>

      {!isTableCell && value && <LongMenu options={options} />}
      {previewDialogs}
    </div>
  )
}

export default memo(
  FilePreviewField,
  (prevProps, nextProps) =>
    prevProps.value === nextProps.value &&
    prevProps.helperText === nextProps.helperText &&
    prevProps.disabled === nextProps.disabled,
)
